export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/745ea77b1eac57714916b21323fd342f.png";